export function FiltersTabComponent() {
  return {
    restrict: 'E',
    template: require('./filters-tab.component.html'),
    scope: false,
  };
}



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/filters-tab.component.js